import { Schema } from 'effect';
import { LogMessageLevelSchema } from './mission';
import { TimestampSchema } from './timestamp';

export const UssConnectionState = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected'
} as const;

export const UssConnectionStateSchema = Schema.Literal(UssConnectionState.CONNECTED, UssConnectionState.DISCONNECTED);

export type UssConnectionState = Schema.Schema.Type<typeof UssConnectionStateSchema>;

export const UssConnectionStateNotificationSchema = Schema.Struct({
  state: UssConnectionStateSchema
});
export type UssConnectionStateNotification = Schema.Schema.Type<typeof UssConnectionStateNotificationSchema>;

export const UssLogMessageNotificationSchema = Schema.Struct({
  level: LogMessageLevelSchema,
  text: Schema.String,
  timestamp: TimestampSchema
});
export type UssLogMessageNotification = Schema.Schema.Type<typeof UssLogMessageNotificationSchema>;
